import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { Component } from "react";
import { DeliveraCategoryInterface } from "../../../controller/model/delivera/DeliveraCategorie";
import DeliveraMenuEntity from "../../../controller/model/delivera/DeliveraEntity";
import { DeliveraStore } from "../../../controller/model/delivera/DeliveraStore";

interface StateInterface {
  isOpen: boolean;
  category: DeliveraCategoryInterface | undefined;
  name: string;
  items: string[];
  description: string;
}

interface PropsInterface {
  store: DeliveraStore;
  onClickSave: (category: DeliveraCategoryInterface) => void;
  onClickCreate: (category: DeliveraCategoryInterface) => void;
}

export default class CategoryDetailModalComponent extends Component {
  public state: StateInterface;
  public props: PropsInterface;

  constructor(props: any) {
    super(props);
    this.state = {
      isOpen: false,
      category: undefined,
      name: "",
      description: "",
      items: [],
    };
    this.props = props;
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.openModalWithCategory = this.openModalWithCategory.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  public openModalWithCategory(
    category: DeliveraCategoryInterface | undefined
  ) {
    this.setState({
      category: category,
      name: DeliveraStore.retreiveNameFromTranslation(category?.title),
      description: DeliveraStore.retreiveNameFromTranslation(
        category?.subtitle
      ),
      isOpen: true,
      items: category?.entities.map((e) => e.id) ?? [],
    });
  }

  private getMenuFromCategorie() {
    return this.props.store.menus?.find((m) =>
      m.category_ids.indexOf(this.state.category?.id ?? "")
    );
  }

  render() {
    return (
      <div style={{ overflow: "scroll" }}>
        <Dialog
          open={this.state.isOpen}
          onClose={this.handleCloseModal}
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogTitle style={{ backgroundColor: "#474F5E", color: "white" }}>
            {this.state.category
              ? `Modification de ${DeliveraStore.retreiveNameFromTranslation(
                  this.state.category.title
                )}`
              : "Création d'une catégorie"}

            <div style={{ fontSize: "15px" }}>
              {this.getMenuFromCategorie()
                ? `Catégorie dans le Menu ${DeliveraStore.retreiveNameFromTranslation(
                    this.getMenuFromCategorie()?.title
                  )}`
                : "Catégories présent dans aucun Menu"}
            </div>
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                display: "inline-block",
                width: "80%",
                marginLeft: "10%",
              }}
            >
              <p
                style={{
                  color: "#474F5E",
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              >
                Nom de la Catégorie{" "}
              </p>
              <TextField
                variant="outlined"
                fullWidth={true}
                value={this.state.name}
                onChange={(event) => {
                  this.setState({
                    name: event.target.value,
                  });
                }}
              />
              <p
                style={{
                  color: "#474F5E",
                  fontSize: "15px",
                  fontWeight: "bold",
                  marginTop: "50px",
                }}
              >
                Description de la Catégorie
              </p>
              <TextField
                variant="outlined"
                multiline
                fullWidth={true}
                value={this.state.description}
                onChange={(event) => {
                  this.setState({
                    description: event.target.value,
                  });
                }}
              />
            </div>
          </DialogContent>
          <DialogActions style={{ margin: "20px" }}>
            <Button
              variant="contained"
              color="primary"
              style={{ color: "white" }}
              onClick={this.handleCloseModal}
            >
              Annuler
            </Button>
            <Button
              style={{ color: "white" }}
              variant="contained"
              color="secondary"
              onClick={(_) => {
                if (this.state.category === undefined) {
                  this.props.onClickCreate(this.createCategorie());
                } else {
                  this.props.onClickSave(this.createCategorie());
                }
              }}
            >
              Enregister
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  public handleCloseModal(_event?: any, _reason?: any) {
    this.setState({
      isOpen: false,
    });
  }

  private createCategorie(): DeliveraCategoryInterface {
    let updatedCategorie = Object.assign({}, this.state.category);

    updatedCategorie["title"] = {
      translations: {
        fr: this.state.name,
        en: this.state.name,
      },
    };
    updatedCategorie["subtitle"] = {
      translations: {
        fr: this.state.description,
        en: this.state.description,
      },
    };
    updatedCategorie["entities"] = this.state.items.map(
      (i) => new DeliveraMenuEntity({ id: i, type: "ITEM" })
    );

    return updatedCategorie;
  }
}
